import React, { useState, useLayoutEffect } from 'react';
// 다국어
import { useTranslation } from 'react-i18next';
// @mui
import { styled } from '@mui/material/styles';
import { Stack, Paper, Link, Box, Modal, Typography } from '@mui/material';
// utils
import IconBlog from '../../../image/icon_blog.png';
import IconFacebook from '../../../image/icon_facebook.png';
import IconSugarpole from '../../../image/icon_sugarpole.png';
import IconYoutube from '../../../image/icon_youtube.png';

import TermsOfUseModal from '../../../components/ModalComponent/TermsOfUseModal';
import PrivacyPolicy from '../../../components/ModalComponent/PrivacyPolicy';

// ----------------------------------------------------------------------

const FOOTER_MOBILE = 64;

const FOOTER_DESKTOP = 100;

const StyledRoot = styled('div')(({ theme }) => ({
  width: `calc(100%)`,
  backgroundColor: `#111`,
  padding: '60px 0',
  display: 'flex',
  flexDirection: 'column',
}));

const Toolbar = styled('div')(({ theme }) => ({
  padding: '0 10%',
  background: 'none',
  display: 'flex',
  flexDirection: 'column',
  height: 'auto',
}));
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: '#fff',
  width: '32px',
  height: '32px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '50%',
  fontSize: 0,
}));

const Text = styled('p')(({ theme }) => ({
  color: '#fff',
  fontWeight: '500',
}));

// ----------------------------------------------------------------------

export default function Footer() {
  const { t, i18n } = useTranslation(['page']);
  const [termsModalOpen, setTermsModalOpen] = React.useState(false);
  const [privacyPolicyModalOpen, setPrivacyPolicyModalOpen] = React.useState(false);

  const termsHandleOpen = () => {
    setTermsModalOpen(true);
  };
  const termsHandleClose = () => {
    setTermsModalOpen(false);
  };

  const privacyPolicyHandleOpen = () => {
    setPrivacyPolicyModalOpen(true);
  };
  const privacyPolicyHandleClose = () => {
    setPrivacyPolicyModalOpen(false);
  };

  return (
    <>
      <StyledRoot>
        <Toolbar>
          <Stack
            style={{ justifyContent: 'space-between', marginBottom: '40px', flexDirection: 'row' }}
            direction={'row'}
          >
            <Stack spacing={8} direction={'row'}>
              <Link
                href="https://sugarpole.com/public/sub/company.php"
                underline="hover"
                color="#fff"
                target="_blank"
                rel="noopener"
              >
                {t('회사소개')}
              </Link>
              <Link href="/license" underline="hover" color="#fff">
                {t('이용안내')}
              </Link>
              {/* <Link href="/community" underline="hover" color="#fff" target="_blank" rel="noopener">FAQ</Link> */}
              <Link href="#!" onClick={termsHandleOpen} underline="hover" color="#fff" rel="noopener">
                {t('이용약관')}
              </Link>
              <Link href="#!" onClick={privacyPolicyHandleOpen} underline="hover" color="#fff" rel="noopener">
                {t('개인정보처리방침')}
              </Link>
            </Stack>
            <Stack spacing={2} direction={'row'}>
              <Item>
                <Link href="https://sugarpole.com/" target="_blank" rel="noopener">
                  <img src={IconSugarpole} alt="sugarpole" />
                </Link>
              </Item>
              <Item>
                <Link href="#" target="_blank" rel="noopener">
                  <img src={IconFacebook} alt="facebook" />
                </Link>
              </Item>
              <Item>
                <Link href="#" target="_blank" rel="noopener">
                  <img src={IconYoutube} alt="youtube" />
                </Link>
              </Item>
              <Item>
                <Link href="#" target="_blank" rel="noopener">
                  <img src={IconBlog} alt="blog" />
                </Link>
              </Item>
            </Stack>
          </Stack>
          <Stack color={'#999'}>
            <p>
              {t('주식회사 슈가폴 | 대표 김수현 | 사업자등록번호 123-86-46579 | 통신판매업신고번호 2015-경기군포-0286')}
            </p>
            <p>{t('주소 서울시 구로구 디지털로 306, 1111호(대륭포스트타워 2차)')}</p>
            <p>{t('이메일 contact@sugarpole.com | 전화 02-6956-1465 | 팩스 02-6949-0363')}</p>
            <p>{t('전화상담 평일 09:00-17:00')}</p>
          </Stack>
        </Toolbar>
      </StyledRoot>

      <TermsOfUseModal modalOpen={termsModalOpen} handleClose={termsHandleClose} />
      <PrivacyPolicy modalOpen={privacyPolicyModalOpen} handleClose={privacyPolicyHandleClose} />
    </>
  );
}
